<template>
  <div>
    <div class="mb-[20px] flex items-center justify-between gap-[20px]">
      <h2
        class="font-roboto text-[32px] font-medium leading-[38px] text-new-test-black"
      >
        <NuxtLink to="/read/articles/zhurnal-ideologiya-budushchego">
          Журнал «Идеология будущего»
        </NuxtLink>
      </h2>
      <NuxtLink
        to="/magazines"
        class="text-[18px] font-medium leading-[22px] text-new-test-black"
      >
        Смотреть все
      </NuxtLink>
    </div>
    <div class="relative">
      <ClientOnly>
        <Swiper
          :breakpoints="breakpoints"
          :slides-per-view="1"
          :space-between="20"
          @swiper="onSwiper"
        >
          <SwiperSlide v-for="(project, index) in specialProjects" :key="index">
            <MainPageCardsReworkedBaseCard
              :aspect="{ w: 1, h: 1 }"
              :data="project"
              position-image="object-top"
              :is-blank="project.isBlank"
              disable-label
            />
          </SwiperSlide>
        </Swiper>
      </ClientOnly>

      <SlidersSliderControl
        type="prev"
        class="absolute left-[-16px] top-45% z-10 hidden md:block"
        :class="isBeginning ? 'opacity-50' : 'cursor-pointer'"
        @click="slidePrev()"
      />
      <SlidersSliderControl
        type="next"
        class="absolute right-[-16px] top-45% z-10 hidden md:block"
        :class="isEnd ? 'opacity-50' : 'cursor-pointer'"
        @click="slideNext()"
      />
    </div>
  </div>
</template>

<script setup>
import 'swiper/css';

import { Swiper, SwiperSlide } from 'swiper/vue';

const { magazines } = useMagazines();

const { onSwiper, slideNext, slidePrev, isBeginning, isEnd } = useSwiper();

const magazinesData = computed(() => magazines.data.value?.data || []);

const getTitle = (item) => {
  return `Выпуск ${item?.attributes?.number}`;
};

const getMainImage = (item) => {
  const mainImageId = item?.attributes?.main_image_id;
  return item?.attributes?.main_image_id
    ? item?.relationships?.images?.find((image) => image.id === mainImageId)
    : item?.relationships?.images?.[0];
};

const specialProjects = computed(() => {
  return magazinesData.value?.map((item) => {
    return {
      model_type: 'specialproject',
      slug: item?.attributes.outer_link
        ? item.attributes.outer_link
        : item.attributes.url_pdf,
      image: getMainImage(item),
      title: getTitle(item),
      announce: '',
      isBlank: true,
    };
  });
});

const breakpoints = {
  1024: {
    slidesPerView: 2,
  },
  1280: {
    slidesPerView: 3,
  },
};
</script>
